import React from 'react'
import { Select, SelectProps } from '@mantine/core'
import { color } from 'src/variable/constant'

function CustomSelect({
	sx,
	...props
}: SelectProps & React.RefAttributes<HTMLInputElement>) {
	return (
		<Select
			sx={{
				minWidth: 240,
				minHeight: 36,
				input: {
					borderRadius: 8,
					borderColor: '#dbe5dd',
					background: '#ffffff',
					fontWeight: 600,
					':focus': {
						borderColor: color.CmsPrimary,
					},
				},
				'.mantine-Select-item': {
					'&[data-selected]': {
						backgroundColor: color.CmsPrimary,
						'&:hover': {
							backgroundColor: color.CmsPrimary,
						},
					},
				},
				...sx,
			}}
			{...props}
		/>
	)
}

export default React.memo(CustomSelect)
